import styled from 'styled-components';

export const DashboardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 12px 0;
  flex: 1;
  position: relative;
}`;
